import iconcall from "../../assets/icons/IconCall.svg";
import iconmail from "../../assets/icons/IconMail.svg";
import iconperson from "../../assets/icons/iconPerson.svg";
import iconlocation from "../../assets/icons/IconLocation.svg";
import { useState } from "react";


const HomeContact = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError("");

    // prepare your form data (adjust fields as needed)
    const mailPayload = {
      "name": name,
      "email": email,
      "subject": subject,
      "message": message
    };

    try {
      const response = await fetch("https://api.fdacadvancedsolutions.com/wp-json/fdac/v1/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mailPayload)
      });

      const result = await response.json().catch(() => null);

      if (response.ok && result?.success !== false) {
        setSuccess(true);
        setName("");
        setEmail("");
        setMessage("");
        setSubject("");
      } else {
        setError(result?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error('Network error:', error);
      setError("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-b from-[#05326D] to-[#315584] text-white px-6 py-12">
      <div className="relative top-40 md:top-64 mb-6 max-w-[var(--max-width)] mx-auto text-center">
        <div className="relative inline-block">
          <h1 className="inline-block relative text-3xl md:text-4xl text-white mb-4 font-normal text-[32px]">
            Contact Us
            <span className="absolute right-0 -bottom-2 w-[40px] border-b-[6px] border-[#B5AB28] rounded-[6px]"></span>
          </h1>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-[var(--max-width)] mx-auto mt-48 md:mt-72 gap-10">

        <div>
          <h3 className="text-2xl font-semibold mb-4 text-[#6EC1E4]">Connect with us</h3>
          <p className="mb-4 text-sm"><img src={iconmail} className="inline mr-2" />info@fdacadvancedsolutions.com</p>

          <div className="mb-4">
            <p className="font-semibold mb-1"><img src={iconperson} className="inline mr-2" /> Dr. Ashok Omray</p>
            <p className="mb-1 text-sm"><img src={iconmail} className="inline mr-2" />ashokomray@fdacadvancedsolutions.com</p>
            <p className="mb-1 text-sm"><img src={iconcall} className="inline mr-2" /> +91 9967006346</p>
          </div>

          <div className="mb-6">
            <p className="font-semibold mb-1"><img src={iconperson} className="inline mr-2" /> Dr. Sagar M. Vichare</p>
            <p className="mb-1 text-sm"><img src={iconmail} className="inline mr-2" />svichare@fdacadvancedsolutions.com</p>
            <p className="mb-1 text-sm"><img src={iconcall} className="inline mr-2" /> +91 9769638029</p>
          </div>

          <div className="mb-6">
            <p className="font-semibold mb-1"><img src={iconperson} className="inline mr-2" /> Ms. Devika Damania</p>
            <p className="mb-1 text-sm"><img src={iconmail} className="inline mr-2" />devikad@fdacadvancedsolutions.com</p>
            <p className="mb-1 text-sm"><img src={iconcall} className="inline mr-2" /> +91 7738017825</p>
          </div>

          <div className="mb-6">
            <p className="font-semibold mb-1"><img src={iconperson} className="inline mr-2" /> Ms. Nidhi S. Vichare</p>
            <p className="mb-1 text-sm"><img src={iconmail} className="inline mr-2" />nidhiv@fdacadvancedsolutions.com</p>
          </div>
          <div className="mb-6">
            <p className="font-semibold mb-1"><img src={iconperson} className="inline mr-2" /> Mohini R. Patil</p>
            <p className="mb-1 text-sm"><img src={iconmail} className="inline mr-2" />info@fdacadvancedsolutions.com</p>
          </div>
          <div className="mb-6">
            <p className="font-semibold mb-1"><img src={iconperson} className="inline mr-2" /> Akshada S. Vichare</p>
            <p className="mb-1 text-sm"><img src={iconmail} className="inline mr-2" />info@fdacadvancedsolutions.com</p>
          </div>
        </div>

        <div className="rounded-md w-full max-w-md text-white">
          <h3 className="text-xl font-semibold mb-6 text-[#6EC1E4]">
            For Enquiries
          </h3>
          {success ? (
            <div
              role="status"
              aria-live="polite"
              className="flex flex-col items-start gap-3 rounded-[8px] border border-[#B5AB28] bg-white/10 p-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#B5AB28] text-xl text-black">
                ✓
              </span>
              <p className="text-lg font-semibold">Thank you! Your message has been sent.</p>
              <p className="text-sm opacity-80">
                Our team will get back to you shortly at the email address you provided.
              </p>
              <button
                type="button"
                onClick={() => setSuccess(false)}
                className="mt-2 border border-white py-1.5 px-4 text-sm rounded transition cursor-pointer hover:bg-white/10"
              >
                Send another message
              </button>
            </div>
          ) : (
          <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
            <div className="flex flex-col space-y-1">
              <label className="text-[#ffffff] text-md">Enter your name*</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="p-2 border border-[#ffffff] rounded-[8px] bg-transparent text-white focus:outline-none opacity-50"
                placeholder="Type here"
                required
              />
            </div>

            <div className="flex flex-col space-y-1">
              <label className="text-[#ffffff] text-md">Enter your Email Id*</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="p-2 border border-[#ffffff] rounded-[8px] bg-transparent text-white focus:outline-none opacity-50"
                placeholder="Type here"
                required
              />
            </div>

            <div className="flex flex-col space-y-1">
              <label className="text-[#ffffff] text-md">Subject*</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="p-2 border border-[#ffffff] rounded-[8px] bg-transparent text-white focus:outline-none opacity-50"
                placeholder="Type here"
                required
              />
            </div>

            <div className="flex flex-col space-y-1">
              <label className="text-[#ffffff] text-md">Your Message</label>
              <textarea
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="p-2 border border-[#ffffff] rounded-[8px] bg-transparent text-white focus:outline-none opacity-50"
                placeholder="Type here"
              />
            </div>
            <button
              type="submit"
              className="bg-[#B5AB28] text-black font-medium py-1.5 px-4 text-sm rounded transition w-fit disabled:opacity-50 cursor-pointer"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send"}
            </button>

            {error && (
              <p role="alert" className="text-red-300 text-sm">
                {error}
              </p>
            )}
          </form>
          )}
        </div>

        <div>
          <h3 className="text-2xl font-semibold mb-4 text-[#6EC1E4]">Company Address</h3>
          <div className="mb-4">
            <p className="font-semibold mb-1"><img src={iconlocation} className="inline mr-2" /> Office 1</p>
            <p className="mb-1 text-sm">
              C/501, Redwoods, Vasant Gardens, Off L.B.S. Road, <br />
              Mulund (W), Mumbai, Maharashtra, India. <br />
              Pin - 400080
            </p>
          </div>

          <div className="mb-4">
            <p className="font-semibold mb-1"><img src={iconlocation} className="inline mr-2" /> Office 2</p>
            <p className="mb-1 text-sm">
              Shop No. 101 & 105, Eco Shoppe, Near D. Y. Patil College, <br />
              Varale Road, Talegaon Dabhade, Pune, <br />
              Maharashtra, India. Pin - 410507
            </p>
          </div>

          <div className="mt-6">
            <iframe
              title="office-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609894356!2d72.74109891842986!3d19.082522322838526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b8f57bcb5d23%3A0x8a1e3a6cf29e748e!2sRedwoods%2C%20Vasant%20Gardens%2C%20Mulund%20West%2C%20Mumbai%2C%20Maharashtra%20400080!5e0!3m2!1sen!2sin!4v1694013512642!5m2!1sen!2sin"
              width="80%"
              height="200"
              className="rounded shadow-lg"
              allowFullScreen={true}
              loading="lazy"
            ></iframe>
          </div>
        </div>

      </div>
    </div>
  );
};

export default HomeContact;
